/* «Volver al hotel» (26d): la dirección en japonés, grande, para enseñársela al taxista. */
import { useState } from 'react';
import type { Lugar, Viaje } from '../datos/tipos.ts';
import { Hoja } from '../componentes/Hoja.tsx';
import { fechaDia } from '../texto.ts';

/** Las noches de un hotel, en texto: «del 11 al 14 oct». */
export function nochesDe(v: Viaje, id: string) {
  const dias = v.dias.filter(d => d.hotel === id);
  if (!dias.length) return '';
  const a = fechaDia(dias[0]), z = fechaDia(dias.at(-1)!);
  return dias.length === 1 ? `noche del ${a}` : `del ${a.split(' ')[0]} al ${z}`;
}

export function TarjetaHotel({ v, lugar, grande = false }: { v: Viaje; lugar: Lugar; grande?: boolean }) {
  const [copiado, setCopiado] = useState(false);
  const destino = lugar.lat != null ? `${lugar.lat},${lugar.lon}` : encodeURIComponent(lugar.direccion ?? lugar.nombre);
  const copiar = () => {
    navigator.clipboard?.writeText(lugar.direccionJa ?? lugar.direccion ?? lugar.nombre).catch(() => {});
    setCopiado(true);
    setTimeout(() => setCopiado(false), 1500);
  };
  return (
    <article className={`tarjeta-hotel ${grande ? 'tarjeta-hotel--grande' : ''}`}>
      <p className="tarjeta-hotel__kicker"><span lang="ja">宿</span> · {nochesDe(v, lugar.id).toUpperCase()}</p>
      {lugar.direccionJa ? (
        <>
          <p className="tarjeta-hotel__frase" lang="ja">この住所までお願いします</p>
          <p className="tarjeta-hotel__dir" lang="ja">{lugar.direccionJa}</p>
          <p className="tarjeta-hotel__nombre">{lugar.nombre}</p>
          <p className="tarjeta-hotel__romaji">{lugar.direccion}</p>
        </>
      ) : (
        <>
          <p className="tarjeta-hotel__nombre">{lugar.nombre}</p>
          <p className="tarjeta-hotel__romaji">{lugar.direccion ?? 'Sin dirección en los documentos'}</p>
        </>
      )}
      <div className="acciones">
        <a className="accion accion--ancha" href={`https://www.google.com/maps/dir/?api=1&destination=${destino}`} target="_blank" rel="noopener">Cómo volver ↗</a>
        <button className="accion accion--ancha" type="button" onClick={copiar}>{copiado ? 'Copiada ✓' : 'Copiar la dirección'}</button>
      </div>
    </article>
  );
}

export function HojaHotel({ v, lugar, onCerrada }: { v: Viaje; lugar: Lugar; onCerrada: () => void }) {
  return (
    <Hoja id="hoja-hotel" titulo="hotel-titulo" onCerrada={onCerrada}>
      {() => (
        <>
          <p className="hoja__kicker">帰る · VOLVER AL HOTEL</p>
          <h2 id="hotel-titulo" className="oculto">Volver al hotel</h2>
          <TarjetaHotel v={v} lugar={lugar} grande />
          <p className="texto" style={{ fontSize: '.85rem' }}>Enséñale la pantalla al taxista: la primera línea dice «a esta dirección, por favor».</p>
        </>
      )}
    </Hoja>
  );
}
